import StaticPageTemplate from './StaticPageTemplate';

export default StaticPageTemplate;
